module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./TransferFindView.js"));
	}, "TransferFindView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TransferFindView!./src/pages/Shop/Member/Wallet/Coupon/TransferFind/TransferFindView.js
// module id = 1098
// module chunks = 431